import { render, staticRenderFns } from "./correoCalendario.vue?vue&type=template&id=4e2c0d84&"
import script from "./correoCalendario.vue?vue&type=script&lang=js&"
export * from "./correoCalendario.vue?vue&type=script&lang=js&"
import style0 from "./correoCalendario.vue?vue&type=style&index=0&id=4e2c0d84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports